// Escape-by-default HTML templating. Every interpolated value is escaped unless it is a SafeHtml
// produced by `html` or `raw`. Never assign untrusted strings to innerHTML anywhere else.

const ESCAPES = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;', '`': '&#96;' };

export function escapeHtml(value) {
  return String(value ?? '').replace(/[&<>"'`]/g, (c) => ESCAPES[c]);
}

export class SafeHtml {
  constructor(value) { this.value = value; }
  toString() { return this.value; }
}

/** Mark trusted, static markup (icons, constants) as safe. Never pass user data to raw(). */
export const raw = (value) => new SafeHtml(String(value ?? ''));

function serialize(value) {
  if (value === null || value === undefined || value === false) return '';
  if (value instanceof SafeHtml) return value.value;
  if (Array.isArray(value)) return value.map(serialize).join('');
  return escapeHtml(value);
}

export function html(strings, ...values) {
  let out = strings[0];
  for (let i = 0; i < values.length; i++) out += serialize(values[i]) + strings[i + 1];
  return new SafeHtml(out);
}

export function render(target, template) {
  // eslint-disable-next-line no-restricted-syntax -- the single sanctioned innerHTML sink
  target.innerHTML = template instanceof SafeHtml ? template.value : escapeHtml(template);
  return target;
}

/** Only allow relative app paths or http(s) URLs in href/src built from data. */
export function safeUrl(url) {
  const value = String(url ?? '').trim();
  if (value.startsWith('/') && !value.startsWith('//')) return value;
  try {
    const parsed = new URL(value);
    return ['http:', 'https:', 'mailto:'].includes(parsed.protocol) ? parsed.href : '#';
  } catch {
    return '#';
  }
}
